import { render, staticRenderFns } from "./difficultProblemsDialog.vue?vue&type=template&id=550cca66&scoped=true"
import script from "./difficultProblemsDialog.vue?vue&type=script&lang=js"
export * from "./difficultProblemsDialog.vue?vue&type=script&lang=js"
import style0 from "./difficultProblemsDialog.vue?vue&type=style&index=0&id=550cca66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550cca66",
  null
  
)

export default component.exports